import { Directive, OnChanges, Input, HostBinding } from '@angular/core';
import { AlarmLevel } from 'ops/common/models/alarm-level';
import { Channel, FlagOption } from 'ops/common/models/channel';

const alarmTextClasses = {};
alarmTextClasses[AlarmLevel.Alarm] = 'alarm-text-critical';
alarmTextClasses[AlarmLevel.Caution] = 'alarm-text-caution';
alarmTextClasses[AlarmLevel.Warning] = 'alarm-text-warning';
alarmTextClasses[FlagOption.NORMAL] = 'alarm-text-normal';
alarmTextClasses[AlarmLevel.None] = 'alarm-text-none';

@Directive({
    selector: '[alarmLevelColor]',
    standalone: false,
})
export class AlarmLevelColorDirective implements OnChanges {
    @Input() channel: Channel;
    @Input() status: FlagOption;

    @HostBinding('class') styleClass: string = '';

    private alarmClassLookup;

    constructor() {}

    ngOnChanges(): void {
        if (!this.channel || !this.status) return;
        this.alarmClassLookup = alarmTextClasses;
        this.styleClass = this.getStatusColor();
    }

    getStatusColor() {
        let level: AlarmLevel | FlagOption;
        switch (this.status) {
            case FlagOption.HIGH_HIGH:
                level = this.channel.fcuData.alarmSettingVeryHigh.alarmLevel;
                return this.alarmClassLookup[level];
            case FlagOption.LOW_LOW:
                level = this.channel.fcuData.alarmSettingVeryLow.alarmLevel;
                return this.alarmClassLookup[level];
            case FlagOption.HIGH:
                level = this.channel.fcuData.alarmSettingHigh.alarmLevel;
                return this.alarmClassLookup[level];
            case FlagOption.LOW:
                level = this.channel.fcuData.alarmSettingLow.alarmLevel;
                return this.alarmClassLookup[level];
            case FlagOption.FEEDBACK:
                level = this.channel.fcuData.alarmSettingFeedbackError.alarmLevel;
                return this.alarmClassLookup[level];
            case FlagOption.NORMAL:
                level = FlagOption.NORMAL;
                return this.alarmClassLookup[level];
            default:
                level = AlarmLevel.Alarm;
                return this.alarmClassLookup[level];
        }
    }
}
